var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import React, { forwardRef, useMemo } from 'react';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { CircularProgressStyle } from './styles';
import { RcCircularProgressClasses } from './utils';
var _RcCircularProgress = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcCircularProgress' });
    var classesProp = props.classes, color = props.color, rest = __rest(props, ["classes", "color"]);
    var classes = useMemo(function () { return combineClasses(RcCircularProgressClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiCircularProgress, __assign({}, rest, { color: "inherit", ref: ref, classes: classes })));
});
var RcCircularProgress = styled(_RcCircularProgress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CircularProgressStyle);
RcCircularProgress.defaultProps = {
    size: 24,
    color: 'interactive.f01',
};
RcCircularProgress.displayName = 'RcCircularProgress';
export { RcCircularProgress };
var templateObject_1;
